














































































import Vue from 'vue';
import {
    message
} from '@/utilities/index';
import {
    WebchatUser
} from "@/libs/WebchatSettings";
import TactfulTelInput from './TactfulTelInput.vue';
import PoweredBy from './poweredBy.vue';
import { config } from '../../config';


export default Vue.extend({
    props: ["isFullScreen",
        "profileLangs",
        "userPreferredLang", "closeSelectLang",
    ],
    components: {
        TactfulTelInput,
        PoweredBy,
    },
    data() {
        return {
            user: {
                name: "",
                phone_number: "",
                email: "",
            },
            WhiteLabelUrl: 'https://res.cloudinary.com/tactful/image/upload/v1622640081/tactful_logo_1_mtlklq.svg',
            confirmUser: false,
            payload: {},
            validPhoneNumber: false,
            validEmail: false,
            openSelectLang: false,
            showLoader: false,
            is_standalone: config.VUE_APP_IS_STANDALONE
        };
    },
    computed: {
        enableCollectName() {
            return this.$vstore.settings.state.profileSettings.enableCollectName;
        },
        enableCollectPhone() {
            return this.$vstore.settings.state.profileSettings.enableCollectPhone;
        },
        enableCollectEmail() {
            return this.$vstore.settings.state.profileSettings.enableCollectEmail;
        },
        profileId() {
            return this.$vstore.settings.state.preferenceSettings.profileId;
        },
        channelId() {
            return this.$vstore.settings.state.preferenceSettings.channelId;
        },
        profileName() {
            return this.$vstore.settings.state.preferenceSettings.profile;
        },
        token() {
            return this.$vstore.settings.state.preferenceSettings.token;
        },
        closeButton() {
            return this.$vstore.settings.state.preferenceSettings.closeButton;
        },
        profileDefaultLang() {
            return this.$vstore.settings.state.profileSettings.profileLanguage;
        },
        enableUserChooseLanguage() {
            return this.$vstore.settings.state.profileSettings.enableUserChooseLanguage;
        },
        captureLeadJson() {
            return this.$vstore.settings.state.channelSettings.captureLeadJson;
        },
        enableWhiteLabel() {
            return this.$vstore.settings.state.channelSettings.enableWhiteLabel;
        },
        phoneNumber() {
            return this.user.phone_number;
        },
        email() {
            return this.user.email;
        },
        disableConfirmButton() {
            return (this.user.name === '' || this.confirmUser || !this.validPhoneNumber || !this.validEmail);
        },
    },
    watch: {
        email: {
            immediate: true,
            handler() {
                this.validEmail = this.checkEmailValidation(this.user.email) ? true : false;
            }
        },

        profileLangs: {
            immediate: true,
            handler(newVal, _) {
                if (newVal) {
                    this.showLoader = false;
                }
            }
        }
    },
    mounted() {

        if (this.closeSelectLang) {
            this.$emit('closeSelectLangToggle', false);
        }
        // else{
        //     this.showLoader = true;
        // }
    },
    methods: {
        trimLongMessage(msg: any) {
            if (msg && msg.length > 180) {
                return msg.slice(0, 180) + '...';
            } else if (msg && msg.length <= 180) {
                return msg;
            }
        },
        renderMessage(template: string, obj: any) {
            return message.renderMessage(template, obj);
        },
        identifyUser(user: WebchatUser) {
            this.confirmUser = true;
            this.$emit('identifyUser', user, this.payload);
        },
        closeChatWindow() {
            this.$emit('closeWindow');
        },
        updateOptions(payload: any) {
            this.payload = payload;
        },
        validNumber(valid: Boolean) {
            this.validPhoneNumber = valid;
        },
        checkEmailValidation(email: string) {
            if (!email) return true;
            const re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        maxMinWindow() {
            window.open(window.location.origin + '/webchat/chatChannel.html#?profileId=' + this.profileId + '&token=' + this.token + '&channelId=' + this.channelId + '&closeButton=false', 'Tactful -' + this.profileName + ',resizable,height=736,width=616');
        },
        openSelectLangView() {
            this.openSelectLang = !this.openSelectLang;
            this.$emit('openSelectLangView', this.openSelectLang);
        },
        getRenderingLang() {
            if (this.userPreferredLang) {
                return this.userPreferredLang;
            } else {
                return this.profileDefaultLang;
            }
        }
    },

});
